<template>
  <v-row dense v-if="isActive && distanceGlasses">
    <v-col>
      <v-row>
        <v-col class="text-h5 gray--text">
          Longe
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Esférico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ distanceGlasses.sphericalRightEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ distanceGlasses.sphericalLeftEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Cilíndrico
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ distanceGlasses.cylindricalRightEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ distanceGlasses.cylindricalLeftEye }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="4">
          <v-row dense>
            <v-col class="text-subtitle-2 gray--text text--lighten-1">
              Eixo
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho direito
                </v-col>
              </v-row>

              <v-row dense>
                <v-col> {{ distanceGlasses.axisRightEye }}° </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-body-2">
                  Olho esquerdo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col> {{ distanceGlasses.axisLeftEye }}° </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "GlassesPrescriptionDistanceGlasses",
    props: {
      isActive: Boolean,
      distanceGlasses: Object,
    },
  };
</script>

<style lang="scss" scoped></style>
